import React from "react";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { Box, Container, Grid2, Typography, Button, } from "@mui/material";
import homepageStyles from "../assets/styles/views/homepage.module.css";
import { SouthEast } from "@mui/icons-material";
import { useRecoilValue } from 'recoil';
import { userInfo } from "../auth/AuthProvider";

import { ProcessImageCard } from "../layouts/homepage/ProcessImageCard";
import { CountCard } from "../layouts/homepage/CountCard";
import { PopularAndNewSection } from "../layouts/homepage/PopularAndNewSection";
import { isDebug } from "../utils";
import ContentLayout from "../layouts/ContentLayout";


const HomePage2 = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const auth = useRecoilValue(userInfo);
  if (isDebug()) console.log("## auth", auth, i18n.language);
  
  React.useEffect(() => {
    document.title = 'BWOB';
  }, []);


  return (
    <ContentLayout pageTitle={""} pageDescription={""} addClassName="content-layout-main" >

      {/* 첫번째 영역 */}   
      <Container sx={{ pt: 2, pb: 2 }}>
        <Grid2 container spacing={2} sx={{ flexGrow: 1 }}>

          <Grid2 item size={{ xs: 12, sm: 12, mb: 12, lg: 12, xl: 12 }} >
            <Box size={{ xs: 12, sm: 12, mb: 12, lg: 12, xl: 12 }} sx={{ p: 1 }}>
              <div style={{ /*backgroundColor: "black", color: "white"*/ }}>
                {i18n.language.toLowerCase() === 'ko' ? 
                <>
                  <Typography component="p" variant="h6" 
                            sx={{ fontSize: { xs: '25px', sm: '30px', md: '40px', lg: '45px'}, fontWeight: "500", lineHeight: "1.5", color: "#202124", }}>
                    커피의 &nbsp;
                    <Typography component='span' variant="span" sx={{ fontWeight: '800'}}>향[香]</Typography>을
                  </Typography>
                  <Typography component="p" variant="h6" 
                            sx={{ fontSize: { xs: '25px', sm: '30px', md: '40px', lg: '45px'}, pl: { xs: '95px', sm: '120px', md: '155px', lg: '155px'}, fontWeight: "500", lineHeight: "1.5", color: "#202124", }}>
                    <Typography component='span' variant="span" sx={{ fontWeight: '800'}}>맛[味]</Typography>을
                  </Typography>
                  <Typography component="p" variant="h6" 
                            sx={{ fontSize: { xs: '25px', sm: '30px', md: '40px', lg: '45px'}, pl: { xs: '115px', sm: '140px', md: '170px', lg: '170px'}, fontWeight: "500", lineHeight: "1.5", color: "#202124",}}>
                    <Typography component='span' variant="span" sx={{ fontWeight: '800'}}>생[生]</Typography>을 데이터화 하다.
                  </Typography>
                </>
                :
                <>
                  <Typography component="p" variant="h6" 
                            sx={{ fontSize: { xs: '20px', sm: '25px', md: '30px', lg: '36px'}, fontWeight: "500", lineHeight: "1.5", color: "#202124", }}>
                    <Trans i18nKey='bwob.agenda1' />
                  </Typography>
                  <Typography component="p" variant="h6" 
                            sx={{ fontSize: { xs: '20px', sm: '25px', md: '30px', lg: '36px'}, pl: "20px", fontWeight: "500", lineHeight: "1.5", color: "#202124", }}>
                    <Trans i18nKey='bwob.agenda2' />
                  </Typography>
                  <Typography component="p" variant="h6" 
                            sx={{ fontSize: { xs: '20px', sm: '25px', md: '30px', lg: '36px'}, pl: "40px", fontWeight: "500", lineHeight: "1.5", color: "#202124",}}>
                    <Trans i18nKey='bwob.agenda3' />
                  </Typography>
                </>
                }
              </div>
              
              <div style={{ padding: "30px" }}>
                {i18n.language.toLowerCase() === 'ko' ? 
                <Typography component="div" variant="subtitle1" sx={{ mb: 3.5, fontSize: "1.125rem" }}>
                  2023년 연구특구진흥재단에서 추진한 기술사업화 협업플랫폼 구축사업에 
                  선정된 <strong>부산테크노파크</strong>가 플랫폼 사업의 일환으로 블록체인을 통한 커피 물류 플랫폼 사업을 수행하였습니다. 
                  <br />
                  <strong>BWOB(Best Wave Of Busan)</strong>는 해당 서비스의 브랜드 명입니다.
                </Typography>
                :
                <Typography component="div" variant="subtitle1" sx={{ mb: 3.5, fontSize: "1.125rem" }}>
                  <Trans i18nKey='bwob.description' />
                  <br />
                  <Trans i18nKey='bwob.description_point' />
                </Typography>
                }
              </div>

            </Box>
          </Grid2>

          {/* <Grid2 item size={{ xs: 12, sm: 12, mb: 8, lg: 4, xl: 4 }}  sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }} className={homepageStyles.main_top_coffee_cup_image_grid}>
            <Box className={homepageStyles.main_top_coffee_cup_image_container}>
              <img src={`${process.env.PUBLIC_URL}/images/home/main_top_coffee_cup.svg`} alt="main_top_coffee_cup" />
            </Box>
          </Grid2> */}

          <Grid2 item size={{ xs: 12, sm: 12, mb: 12, lg: 12, xl: 12 }}>
            <Box className={homepageStyles.main_top_quik_button}>
              <Button variant="contained" size="large" 
                  sx={{ background: "#301D06", height: "8", fontsize: "1.125rem", borderRadius: 4, borderTopLeftRadius: 0, borderBottomRightRadius: 0,}} 
                  endIcon={<SouthEast />} onClick={() => navigate("/mypage")} >
                  {t('button.registration4bean')}
              </Button>
            </Box>
          </Grid2>

        </Grid2>
      </Container>

      {/* 두번째 영역 */}
      <Container sx={{ pt: 8, pb: 6 }}>
        <ProcessImageCard />
      </Container>

      {/* 세번째 영역 */}
      <Container sx={{ pt: 8, pb: 6 }}>
        <CountCard />
      </Container>

      {/* 네번째 영역 S */}
      <Container sx={{ pt: 8, pb: 6 }}>
        <PopularAndNewSection />
      </Container>

    </ContentLayout>
  );
};

export default HomePage2;
